<!--  -->
<template>
<div class="article">
    <!-- <div @click="goApp">555555555555</div> -->
    <div class="content">
        <div class="imgList" v-if="imgList.length > 0">
            <van-swipe @change="onChange" class="my-swipe">
                <van-swipe-item v-for="(image, index) in imgList" :key="index">
                    <img :src="image" />
                </van-swipe-item>
                <template #indicator>
                    <div class="custom-indicator">{{ current + 1 }}/{{imgList.length}}</div>
                </template>
            </van-swipe>
        </div>
        <div v-if="videoList.length>0" class="videoList">
            <video :src="videoList[1]" :poster="videoList[0]" controls></video>
        </div>
        <div class="author">
            <div class="imgName" @click="goApp">
                <img :src="articleInfo.author_icon">
                <span>{{articleInfo.author_name}}</span>
            </div>
            <div class="other">
                <span class="time">{{diffTime(articleInfo.create_time&&articleInfo.create_time.replace(/T/g," "))}}</span>
                <span class="position">{{articleInfo.position}}</span>
            </div>
        </div>
        <div class="con">
            <span class="title">{{articleInfo.title}}</span>
            <div class="content" v-html="articleInfo.content"></div>
        </div>
        <div class="talk">
            <span v-for="(item,index) in talk" :key="index" @click="goApp"><i>#</i>{{item}}</span>
        </div>
    </div>
    <div class="goods" v-if="goods.length > 0">
        <ul>
            <li v-for="(item,index) in goods" :key="index" @click="goApp" :class="[goods.length == 1?'one':'']">
                <img :src="item.cover_url">
                <div class="goodName">
                    <span class="name">{{item.good_name}}</span>
                    <span class="good_amount">¥{{item.good_amount}}</span>
                </div>
            </li>
        </ul>
    </div>
    <div class="commentList" :class="[goods.length == 0?'noShop':'']">
        <div class="total">
            <span>评论 {{commensTotal}}</span>
            <span>赞 {{likeTotal}}</span>
        </div>
        <div class="comments">
            <ul class="commentsUl">
                <li v-for="(item,index) in commentsList" :key="index" class="commentLi">
                    <div class="head" @click="goApp">
                        <img :src="item.comment_people_icon">
                    </div>
                    <div class="rightHead">
                        <div class="headTop">
                            <div class="left" @click="goApp">
                                <span>{{item.comment_people_name}}<i class="isAuthor" v-if="item.comment_people_id == item.author_id">作者</i></span>
                                <span>{{diffTime(item.comment_time.replace(/T/g," "))}}</span>
                            </div>
                            <div class="right" @click="goApp">
                                <img src="../../assets/img/zan.png">
                                <span>{{item.fabulous_count}}</span>
                            </div>
                        </div>
                        <div class="con">
                            <p v-html="item.content"></p>
                        </div>
                        <div class="comment_two" v-if="item.reply_comments&&item.reply_comments.length > 0">
                            <ul>
                                <li v-for="(it,ind) in item.reply_comments" :key="ind">
                                    <div class="headImg" @click="goApp">
                                        <img :src="it.comment_people_icon">
                                    </div>
                                    <div class="twoOther" @click="goApp">
                                        <span class="name">{{it.comment_people_name}}</span>
                                        <span class="time">{{diffTime(it.comment_time.replace(/T/g," "))}}</span>
                                        <p class="content">{{it.content}}</p>
                                    </div>
                                </li>
                            </ul>
                            <div class="ask_count" v-if="item.ask_count > 5" @click="goApp">共{{item.ask_count}}条回复<img src="../../assets/img/right.png"></div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="noData" v-if="commentsList.length == 0">
                <img src="../../assets/img/ques.png">
                <span>动动小手，留下你的痕迹ᕦ(･ㅂ･)ᕤ</span>
            </div>
        </div>
    </div>
    <div class="goAPP">
        <span @click="goApp">打开APP查看更多内容</span>
    </div>

</div>
</template>

<script>
import { getArticle, commentList } from '../../api/index'
export default {
    name: '',
    components: {},
    data() {
        return {
            articleInfo: {},
            articleId: 0,
            videoList: [],
            imgList: [],
            talk: [],
            goods: [],
            current: 0,
            isBlur: false,
            loadTime: null,
            commentsList: [],
            commensTotal: 0,
            likeTotal: 0,
        };
    },
    computed: {},

    created() {
        this.articleId = this.$route.query.id || 15
        this.getArticle()
        this.getCommentList()
        var self = this
        document.addEventListener('visibilitychange webkitvisibilitychange', function () {
            var tag = document.hidden || document.webkitHidden;
            if (tag) {
                clearTimeout(self.loadTime);
            }
        })
        window.onpagehide = function () {
            clearTimeout(self.loadTime);
        }
        window.onbeforeunload = function () {
            clearTimeout(self.loadTime);
        }
        var hidden, visibilityChange;
        if (typeof document.hidden !== "undefined") {
            hidden = "hidden";
            visibilityChange = "visibilitychange";
        } else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden";
            visibilityChange = "mozvisibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
        }

        document.addEventListener(visibilityChange, function () {
            if (document[hidden]) {
                console.log('用户没有浏览当前页面，清除定时器');
                clearTimeout(self.loadTime);
            } else {
                console.log('用户有浏览当前页面,正常发送报错信息');
            }
        })
    },
    methods: {
        getArticle() {
            let data = {
                id: this.articleId
            }
            getArticle(data).then(res => {
                this.articleInfo = res.data
                if (res.data.video) {
                    this.videoList = res.data.video.split(',')
                } else {
                    this.imgList = res.data.image.split(',')
                }
                this.talk = res.data.talk && res.data.talk.split(',')
                this.goods = res.data.goods || []
                this.likeTotal = res.data.like_count
                // console.log(this.videoList, this.imgList)
            })
        },
        getCommentList() {
            let data = {
                current: 1,
                size: 5,
                article_id: this.articleId
            }
            commentList(data).then(res => {
                this.commentsList = res.data.records
                this.commensTotal = res.data.total
                console.log(this.commentsList)
            })
        },
        goApp() {
            let url = "mobile://upupoo.com?action=1&id=" + this.articleId
            this.isBlur = false
            this.clickDownload(url)
        },
        onChange(index) {
            this.current = index;
        },
        //检查app是否打开
        clickDownload(url) {
            var self = this
            if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                var loadDateTime = new Date();
                window.location.href = url; //schema链接或者universal link
                this.loadTime = window.setTimeout(function () { //如果没有安装app,便会执行setTimeout跳转下载页
                    var timeOutDateTime = new Date();
                    if (timeOutDateTime - loadDateTime < 5000) {
                        // alert('没下')
                        self.$router.push({ path: '/download' })
                        // window.location = "http://www.upupoo.com"; //ios下载地址  
                    } else {
                        window.close();
                    }
                }, 1000);

            } else if (navigator.userAgent.match(/android/i)) {
                var state = null;
                try {
                    window.location.href = url; //schema链接或者universal link
                    window.location.href = url
                    this.loadTime = window.setTimeout(function () {
                        // alert('没下')
                        self.$router.push({ path: '/download' })
                        // window.location = "http://www.upupoo.com"; //android下载地址  
                    }, 1000);
                } catch (e) {}
            }
        },
        diffTime(time) {
            let dateTimeStamp = new Date(time).getTime()
            var minute = 1000 * 60;
            var hour = minute * 60;
            var day = hour * 24;
            var halfamonth = day * 15;
            var month = day * 30;
            var content = '';
            var now = new Date().getTime();
            var diffValue = now - dateTimeStamp;

            var monthC = diffValue / month;
            var weekC = diffValue / (7 * day);
            var dayC = diffValue / day;
            var hourC = diffValue / hour;
            var minC = diffValue / minute;
            if (dayC > 7) {
                content = time.split(' ')[0]
            } else if (dayC >= 1 && dayC <= 7) {
                content = parseInt(dayC) + '天前'
            } else if (parseInt(hourC) >= 1) {
                content = parseInt(hourC) + "小时前";
            } else if (parseInt(minC) >= 1) {
                content = parseInt(minC) + "分钟前";
            } else if (parseInt(minC) < 1) {
                content = "1分钟前";
            }
            return content
        }

    },
}
</script>

<style lang="scss" scoped>
.article {
  background: #f0f3f5;
}

.goAPP {
  position: fixed;
  bottom: 0.4rem;
  left: 1.6rem;
  right: 1.6rem;

  span {
    display: block;
    width: 100%;
    background: #3f96fd;
    box-shadow: 0 0.02rem 0.11rem 0.01rem rgba(63, 150, 253, 0.4);
    border-radius: 0.44rem;
    text-align: center;
    height: 0.88rem;
    line-height: 0.88rem;
    font-size: 0.32rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
  }
}

.custom-indicator {
  position: absolute;
  width: 0.8rem;
  height: 0.4rem;
  background: #292929;
  opacity: 0.32;
  border-radius: 0.2rem;
  right: 0.24rem;
  bottom: 0.32rem;
  display: flex;
  text-align: center;
  font-size: 0.2rem;
  color: #fff;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.content {
  width: 100%;
  background: #fff;

  .imgList {
    width: 100%;
    max-height: 10.8rem;

    .my-swipe {
      position: relative;

      .van-swipe-item {
        display: flex;
        text-align: center;
        align-items: center;
        align-content: center;
        justify-content: center;
        max-height: 10.8rem;
        overflow: hidden;

        img {
          width: 100%;
          object-fit: cover;
          height: 10.8rem;
        }
      }
    }
  }

  .videoList {
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    max-height: 10.8rem;

    video {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .author {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 0.22rem;
    height: 0.56rem;
    align-content: center;
    align-items: center;
    margin-top: 0.4rem;

    .imgName {
      display: flex;
      align-content: center;
      align-items: center;

      img {
        width: 0.56rem;
        height: 0.56rem;
        border-radius: 50%;
        margin-right: 0.16rem;
      }

      span {
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #a3a3a3;
        max-width: 3rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .other {
      display: flex;
      align-content: center;
      align-items: center;
      font-size: 0.2rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #b8b8b8;

      .time {
        margin-right: 0.07rem;
      }
    }
  }

  .con {
    margin-top: 0.52rem;
    text-align: left;
    padding: 0 0.32rem;

    .title {
      font-size: 0.32rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #292929;
      line-height: 1;
      margin-bottom: 0.32rem;
      display: block;
    }

    .content {
      font-size: 0.32rem;
      color: #292929;
      line-height: 0.52rem;
    }
  }

  .talk {
    display: flex;
    flex-flow: wrap;
    width: 100%;
    padding: 0 0.32rem;
    padding-bottom: 0.32rem;
    margin-top: 0.4rem;

    span {
      height: 0.42rem;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      padding: 0 0.16rem;
      font-size: 0.24rem;
      color: #3f96fd;
      background: #e8f1fc;
      border-radius: 21px;
      margin-right: 0.16rem;
      margin-bottom: 0.16rem;

      i {
        margin-right: 0.07rem;
      }
    }
  }
}

.goods {
  overflow-x: auto;

  ul {
    overflow-x: scroll;
    display: flex;
    margin: 0.24rem 0;
    margin-bottom: 0;
    padding-bottom: 0.24rem;

    li {
      background: #fff;
      display: flex;
      justify-content: space-between;
      flex: 0 0 5.2rem;
      height: 1.96rem;
      align-items: center;
      align-content: center;
      background: #fff;
      border-radius: 0.16rem;
      margin-left: 0.24rem;
      padding: 0.18rem;
      overflow: hidden;

      &:last-child {
        margin-right: 0.24rem;
      }

      img {
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 0.16rem;
        margin-right: 0.17rem;
      }

      .goodName {
        flex: 1;
        height: 100%;
        text-align: left;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .name {
          font-size: 0.28rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #292929;
          line-height: 0.4rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }

        .good_amount {
          font-size: 0.24rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #fb3958;
          margin-bottom: 0.08rem;
        }
      }

      &.one {
        flex: 0 0 6.72rem;
      }
    }
  }
}

.commentList {
  background: #fff;
  padding: 0.32rem;
  padding-bottom: 1.3rem;

  &.noShop {
    margin-top: 0.24rem;
  }

  .total {
    display: flex;

    justify-content: space-between;

    span {
      font-size: 0.24rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #b8b8b8;
    }
  }

  .comments {
    margin-top: 0.4rem;

    .commentsUl {
      width: 100%;

      .commentLi {
        margin-bottom: 0.4rem;
        width: 100%;
        display: flex;

        .head {
          width: 0.6rem;
          height: 0.6rem;
          margin-right: 0.16rem;

          img {
            width: 0.6rem;
            height: 0.6rem;
            border-radius: 50%;
          }
        }

        .rightHead {
          flex: 1;

          .headTop {
            display: flex;
            width: 100%;
            height: 0.6rem;
            align-content: center;
            align-items: center;
            justify-content: space-between;

            .left {
              margin-top: 0.04rem;

              span {
                font-size: 0.2rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #a3a3a3;
                line-height: 1;
                display: block;
                margin-bottom: 0.12rem;
                text-align: left;
                position: relative;
                overflow: hidden;
                max-width: 5rem;
                &:first-child {
                  font-size: 0.24rem;
                }

                &:last-child {
                  margin-bottom: 0;
                }

                .isAuthor {
                  margin-left: 0.04rem;
                  height: 0.24rem;
                  width: 0.54rem;
                  font-size: 0.2rem;
                  text-align: center;
                  background: #f7fafc;
                  border: 1px solid #3f96fd;
                  border-radius: 4px;
                  display: inline-flex;
                  justify-content: center;
                  align-content: center;
                  align-items: center;
                  color: #3f96fd;
                }
              }
            }

            .right {
              display: flex;
              align-content: center;
              align-items: center;

              img {
                width: 0.4rem;
                height: 0.4rem;
              }

              span {
                font-size: 0.2rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #a3a3a3;
                margin-top: 0.02rem;
              }
            }
          }

          .con {
            width: 100%;
            margin-top: 0.26rem;
            text-align: left;
            font-size: 0.28rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #292929;
            line-height: 0.48rem;
          }

          .comment_two {
            width: 100%;
            margin-top: 0.24rem;
            background: #fafafa;
            border-radius: 0.1rem;

            ul {
              width: 100%;

              li {
                width: 100%;
                display: flex;
                padding: 0.24rem;
                padding-bottom: 0.16rem;

                .headImg {
                  width: 0.4rem;
                  height: 0.4rem;
                  border-radius: 50%;
                  margin-right: 0.15rem;

                  img {
                    width: 0.4rem;
                    height: 0.4rem;
                    border-radius: 50%;
                  }
                }

                .twoOther {
                  text-align: left;

                  .name {
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    line-height: 1;
                    font-size: 0.24rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #a3a3a3;
                    display: block;
                  }

                  .time {
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN;
                    margin-top: 0.04rem;
                    font-weight: 400;
                    color: #b8b8b8;
                    display: block;
                  }

                  .content {
                    background: transparent;
                    font-size: 0.28rem;
                    font-family: Source Han Sans CN;
                    margin-top: 0.1rem;
                    font-weight: 400;
                    color: #292929;
                    line-height: 0.48rem;
                  }
                }
              }
            }

            .ask_count {
              text-align: left;
              padding: 0 0.24rem;
              padding-bottom: 0.24rem;
              font-size: 0.24rem;
              line-height: 1;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #3f96fd;
              display: flex;
              align-content: center;
              align-items: center;

              img {
                display: inline-block;
                width: 0.16rem;
                margin-left: 0.04rem;
              }
            }
          }
        }
      }
    }

    .noData {
      width: 100%;

      img {
        width: 3.4rem;
        margin: 0 auto;
        display: block;
        margin-bottom: 0.4rem;
      }

      span {
        text-align: center;
        display: block;
        margin: 0 auto;
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #b8b8b8;
        line-height: 1;
        padding-bottom: 0.5rem;
      }
    }
  }
}
</style>
